import { render, staticRenderFns } from "./EditLabelComponent.vue?vue&type=template&id=909127b2"
import script from "./EditLabelComponent.vue?vue&type=script&lang=js"
export * from "./EditLabelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports